define('viewmodels/Calculations/YearSetup',['knockout', 'plugins/router', 'services/appsecurity', 'services/navigation', 'durandal/app', 'durandal/system', 'services/logger'], function (ko, router, appsecurity, navigation, app, system, logger) {

    var YrViewModel = {
        activate: activate,
        attached: attached,
        appsecurity: appsecurity,
        CreateNewassessmentProfile: CreateNewassessmentProfile,
        CommonChangeYearofassessmentPopUp: CommonChangeYearofassessmentPopUp,
        ChangeProfileofAssessment: ChangeProfileofAssessment,
        popUpTitle: ko.observable(),
        CurrentYear: ko.observable(),
        SourceYear: ko.observable(),
        ProfileName: ko.observable(),
        TargetYear: ko.observable(),
        JobType: ko.observable('ON-DEMAND'),
        JobStatus: ko.observable(),
        addPopUpCss: ko.observable(),
        SourceYearHeatmap: ko.observable(),
        UserMappingList: ko.observableArray([]),
        TargetYearHeatmap: ko.observable(),
        Copyconfigurations: ko.observable(),
        Refreshconfigurations: ko.observable(0),
        typedrpdownchangeRefresh: typedrpdownchangeRefresh,
        CurrentAssesmentProfile: ko.observable(),
        ProfileofAssessmentList: ko.observableArray(),
        editablePeriodOfAssessment: ko.observableArray([]),
        editPeriodOfAssessmentID: ko.observableArray,
        YearofAssessmentList: ko.observableArray(),
        ValidYearDetails: ko.observableArray(),
        ProfileofAssessmentListFilter: ko.observableArray(),
        YearDetails: ko.observableArray(),
        FromDate: ko.observable(),
        ToDate: ko.observable(),
        HistProfileName: ko.observable(),
        PopUpOpenProfileId: ko.observable(),
        AllYearDetails: ko.observableArray([]),
        typedrpdownchange: typedrpdownchange,
        CurrentYearofAssessment: ko.observable(),
        FreezeYearOfAssessment: FreezeYearOfAssessment,
        SaveYearChange: SaveYearChange,
        saveEditAssessmentProfilePopup: saveEditAssessmentProfilePopup,
        SaveChangeYearAssesment: SaveChangeYearAssesment,
        Profilechanged: Profilechanged,
        ProfilechangedChangeYearPopup: ProfilechangedChangeYearPopup,
        OpenUserDetailsPopup: OpenUserDetailsPopup,
        SelectAllUsers: SelectAllUsers,
        SaveUserProfileMapping: SaveUserProfileMapping,
        Freeze: Freeze,
        editAssessmentPeriodDetails: editAssessmentPeriodDetails,
        ControlsAccess: ko.observable(true),
        Savedisabled: ko.observable(true),
        SelectedHistProfile: ko.observable(),
        RefreshScheduledJob: RefreshScheduledJob,
        freezeConfiguration: freezeConfiguration,
        UnfreezeConfiguration: UnfreezeConfiguration

    };
    return YrViewModel;

    function activate() {
        try {
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: activate() method in YearSetup.js';
            logger.logMessage(msg);
        }
    }

    function attached() {
        try {
            GetCurrentassessmentProfile().then(function () {
                YrViewModel.Copyconfigurations(1);
                YrViewModel.Refreshconfigurations(1);
                getAssessmentProfileDetails();
            })
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: attached() method in YearSetup.js';
            logger.logMessage(msg);
        }
    }

    //-------------------------------------------------Function that opens the create new assessment profile popup starts here---------------------------------------------------------------- 
    function CreateNewassessmentProfile(data, event) {
        try {
            if (event.currentTarget.id == "btnAddUser") {

                YrViewModel.ProfileName("");
                YrViewModel.FromDate("");
                YrViewModel.ToDate("");
                YrViewModel.TargetYear("");
                YrViewModel.popUpTitle("Create New Assessment");
                YrViewModel.addPopUpCss(true);
                YrViewModel.YearDetails(YrViewModel.YearofAssessmentList());
                $('#ChangeYearofAssessmentpop').modal('show');
                $('#DisplayAssessmentDate').hide();
                $('#FromDate').datepicker({ dateFormat: 'MM dd yy', changeMonth: true, changeYear: true });
                $('#ToDate').datepicker({ dateFormat: 'MM dd yy', changeMonth: true, changeYear: true });
            }
            else {
                app.showMessage('Are you sure you want to change the assessment period from ' + YrViewModel.CurrentYearofAssessment() + ' to ' + data.YearofAssessment() + '?', 'Change Year of Assessment', ['Confirm', 'Cancel'], true, { buttonClass: "fa fa-check btn btn-primary", primaryButtonClass: "fa fa-check btn btn-success autofocus", popupIcon: 'title-icon col-md-1 fa fa-refresh' })
                    .then(function (option) {
                        if (option === 'Confirm') {

                            if (data.YearofAssessment() != undefined && data.YearofAssessment().length == 4) {
                                YrViewModel.TargetYear(data.YearofAssessment());
                                ChangeYear(YrViewModel.CurrentYearofAssessment(), YrViewModel.TargetYear());
                            }
                            else {
                                YrViewModel.TargetYear("");
                            }
                        }
                    });
            }
        }



        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in CreateNewassessmentProfile() method in YearSetup.js';
            logger.logMessage(msg);
        }
    }
    //------------------------------------------------Function that opens the create new assessment profile ends here------------------------------------------------------------
    function CommonChangeYearofassessmentPopUp() {
        YrViewModel.addPopUpCss(true);
        YrViewModel.popUpTitle("Change Assessment Period");
        $("#CommonChangeYearofAssessment").modal('show');
    }

    function editAssessmentPeriodDetails(data, event) {
        try {
            YrViewModel.editPeriodOfAssessmentID = data.ProfileId();
            $.ajax({
                url: "/api/Calculation/GetProfileAssessmentData",
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            })
                .success(ajaxSuccess)
                .fail(ajaxFail);

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: editAssessmentPeriodDetails() method in YearSetup.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, status) {
            try {

                if (jsonResult != null)
                {
                    if (jsonResult.length > 0 && jsonResult[0].Incident_Description != null) {
                        logger.logError(jsonResult[0].Incident_Description + " - " + 'An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(YrViewModel), true);
                    }

                    if (jsonResult.length > 0)
                    {

                    var MappedPeriodofAssessment = $.map(jsonResult, function (result) {
                        return new ProfileofAssessmentModel(result);
                    });
                    for (var i = 0; i < MappedPeriodofAssessment.length; i++) {
                        if (MappedPeriodofAssessment[i].ProfileId() == YrViewModel.editPeriodOfAssessmentID) {
                            var MappedAssessment = new EditAssessmentProfileModel({ ProfileId: MappedPeriodofAssessment[i].ProfileId(), Profilename: MappedPeriodofAssessment[i].Profilename(), Fromdate: MappedPeriodofAssessment[i].Fromdate(), Todate: MappedPeriodofAssessment[i].Todate(), HistProfileId: MappedPeriodofAssessment[i].HistProfileId })
                            YrViewModel.editablePeriodOfAssessment(MappedAssessment);
                            break;
                        }
                    }
                    YrViewModel.ProfileofAssessmentListFilter([]);

                    for (var i = 0; i < MappedPeriodofAssessment.length; i++) {
                        if (MappedPeriodofAssessment[i].ProfileId() != YrViewModel.editPeriodOfAssessmentID) {
                            var MappedAssessment2 = new EditAssessmentProfileModel({ ProfileId: MappedPeriodofAssessment[i].ProfileId(), Profilename: MappedPeriodofAssessment[i].Profilename(), Fromdate: MappedPeriodofAssessment[i].Fromdate(), Todate: MappedPeriodofAssessment[i].Todate(), HistProfileId: MappedPeriodofAssessment[i].HistProfileId })

                            YrViewModel.ProfileofAssessmentListFilter.push(MappedAssessment2);
                        }
                    }
                    var MappedAssessment2 = new EditAssessmentProfileModel({ ProfileId: '0', Profilename: 'None', HistProfileId: 0 })
                    YrViewModel.ProfileofAssessmentListFilter.push(MappedAssessment2);

                    YrViewModel.popUpTitle("Edit Assessment Period Details");
                    YrViewModel.SelectedHistProfile(YrViewModel.editablePeriodOfAssessment().HistProfileId());
                    $('#editAssessmentPeriodDetails').modal("show")
                    $('#FromDate2').datepicker({ dateFormat: 'MM dd yy', changeMonth: true, changeYear: true });
                    $('#ToDate2').datepicker({ dateFormat: 'MM dd yy', changeMonth: true, changeYear: true });
                }
                }
                else
                    logger.logError('An error occurred while editing Year of Assessment. Please contact your application administrator.', 'Error', system.getModuleId(YrViewModel), true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess from editAssessmentPeriodDetails() method in YearSetup.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();

                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in editAssessmentPeriodDetails() method in YearSetup.js';
                    logger.logMessage(msg);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail from editAssessmentPeriodDetails() method in YearSetup.js';
                logger.logMessage(msg);
            }
        }
    }
    
    function UnfreezeConfiguration(data, event) {
        try {
            if (data.ConfigurationFreezeFlag() == '1') {
                app.showMessage("Unlocking configuration will enable addition and deletion in the Configuration section.Are you sure you wish to proceed?", "Unlock Configuration", ["Yes", "No"], true, { buttonClass: "fa fa-check btn btn-primary", primaryButtonClass: "fa fa-check btn btn-success autofocus", popupIcon: 'title-icon col-md-1 fa fa-unlock-alt' })
                    .then(function (option) {
                        if (option == 'Yes') {
                            UnfreezeConfigurationProfile(data);
                        }

                    });
            }
            else {
                logger.logMessage('Configuration of this profile is not locked.');
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajaxFail from UnfreezeConfiguration() method in YearSetup.js';
            logger.logMessage(msg);
        }
    }
    function UnfreezeConfigurationProfile(data, event) {
        try {
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            return $.ajax({
                url: "/api/Calculation/freezeConfigurationProfile",
                type: "POST",
                headers: headers,
                data: { ProfileId: data.ProfileId(), ConfigurationFreezeFlag: '0' }
            })
                .success(function (jsonResult, error) {
                    logger.logSuccess('Profile has been unlocked successfully.', 'Success', system.getModuleId(YrViewModel), true);
                    getAssessmentProfileDetails();
                    if (data.ProfileId() == YrViewModel.appsecurity.CurrentProfileOfAssessmentId()) {
                        YrViewModel.appsecurity.GetConfigurationFreezeFlag();
                    }
                })
                .fail(function (error, status) {
                    logger.logError('An error has occurred while unlocking profile. Please contact your Administrator.', 'Error', system.getModuleId(YrViewModel), true);
                });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: UnfreezeConfigurationProfile() method in YearSetup.js';
            logger.logMessage(msg);
        }
    }

    function freezeConfiguration(data, event) {
        try {
            if (data.ConfigurationFreezeFlag() == '0') {
                app.showMessage("</br>Do you want to lock configurations for " + data.Profilename() + "? </br>"
                    +"By clicking the <b>Confirm</b> button, I acknowledge the following:<ol>"
                +"<li>Risk assessment results are finalized and there are no further changes expected;</li>"
                    +"<li>I have the required approvals from the Compliance team to perform this action; and</li>"
                    +"<li>The action cannot be rolled back without the intervention of system administrators.</li>"
                    +"</ol>If you do not wish to proceed, please click <b>Cancel</b>"
                    , "Lock Configuration - Acknowledgement", ["Confirm", "Cancel"], true, { buttonClass: "fa fa-check btn btn-primary", primaryButtonClass: "fa fa-check btn btn-success", popupIcon: 'title-icon col-md-1 fa fa-lock' })
                    .then(function (option) {
                        if (option == 'Confirm') {
                            freezeConfigurationProfile(data);
                        }
                       
                    });
            }
            else {
                logger.logMessage('Configuration of this profile is already locked.');
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajaxFail from freezeConfiguration() method in YearSetup.js';
            logger.logMessage(msg);
        }
    }

    function freezeConfigurationProfile(data, event) {
        try {
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            return $.ajax({
                url: "/api/Calculation/freezeConfigurationProfile",
                type: "POST",
                headers: headers,
                data: { ProfileId: data.ProfileId(), ConfigurationFreezeFlag:'1' }
            })
                .success(function (jsonResult, error) {
                    logger.logSuccess('Profile has been locked successfully.', 'Success', system.getModuleId(YrViewModel), true);
                    getAssessmentProfileDetails();
                    if (data.ProfileId() == YrViewModel.appsecurity.CurrentProfileOfAssessmentId()) {
                        YrViewModel.appsecurity.GetConfigurationFreezeFlag();
                    }

                })
                .fail(function (error, status) {
                    logger.logError('An error has occurred while locking profile. Please contact your Administrator.', 'Error', system.getModuleId(YrViewModel), true);
                });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: freezeConfigurationProfile() method in YearSetup.js';
            logger.logMessage(msg);
        }
    }

    function getAssessmentProfileDetails() {
        try {
            $.ajax({
                url: "/api/Calculation/GetProfileAssessmentData",
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            })
                .success(ajaxSuccess)
                .fail(ajaxFail);

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: getAssessmentProfileDetails() method in YearSetup.js';
            logger.logMessage(msg);
        }
        function ajaxSuccess(jsonResult, status) {
            try {

            if (jsonResult != null)
            {
                if (jsonResult.length > 0 && jsonResult[0].Incident_Description != null) {
                    logger.logError(jsonResult[0].Incident_Description + " - " + 'An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(YrViewModel), true);
                }

                if (jsonResult.length > 0) {
                    var MappedPeriodofAssessment = $.map(jsonResult, function (result) {
                        if (result.ProfileId == YrViewModel.CurrentYear()) {
                            var currentassessmentProfileName = YrViewModel.CurrentAssesmentProfile() + " (From : " + result.Fromdate + " To : " + result.Todate + ")";
                            YrViewModel.CurrentAssesmentProfile(currentassessmentProfileName)
                        }
                        return new ProfileofAssessmentModel(result);
                    });


                    tableObj = $('#tblReportDetails').DataTable();
                    tableObj.destroy();
                    $('#tblReportDetails tbody tr').remove();
                    QuestionTableObj = undefined;
                    YrViewModel.ProfileofAssessmentList([]);
                    YrViewModel.ProfileofAssessmentList(MappedPeriodofAssessment)
                    QuestionTableObj = $('#tblReportDetails').DataTable({
                        "order": [],
                        "aaSorting": [],
                        "bResponsive": true,
                        "aoColumnDefs": [
                            {
                                "aTargets": [1],
                                "bVisible": true,
                                "bSortable": false

                            }, {
                                "aTargets": [2],
                                "bVisible": true,
                                "bSortable": true

                            }, {
                                "aTargets": [4],
                                "bVisible": true,
                                "bSortable": false

                            }, {
                                "aTargets": [5],
                                "bVisible": true,
                                "bSortable": false

                            }],
                        "fnRowCallback": function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                            if (aData[0] == YrViewModel.CurrentYear()) {
                                $('td', nRow).css('background-color', '#CCE5FF');
                            }
                        }

                    });

                    $('#tblReportDetails').DataTable().draw(false);
                }
                }
                else
                    logger.logError('An error occurred while fetching the Current Year of Assessment. Please contact your application administrator.', 'Error', system.getModuleId(YrViewModel), true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess from getAssessmentProfileDetails() method in YearSetup.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();

                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in getAssessmentProfileDetails() method in YearSetup.js';
                    logger.logMessage(msg);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail from getAssessmentProfileDetails() method in YearSetup.js';
                logger.logMessage(msg);
            }
        }

    }

    //-----------------------------------------------------------------Function that is invoked on click of save for the createnew assessment profile starts here---------------------------------
    function SaveYearChange(data, event) {
        try {
            $('#valfactorerror').hide();
            if ((Date.parse(data.ToDate()) - Date.parse(data.FromDate())) > 0) {



                if (YrViewModel.Copyconfigurations() == 0) {
                    data.FromDate();
                    data.ToDate()
                    data.ProfileName();
                    data.SourceYear();
                    CreateNewProfilewithoutsource(data.FromDate(), data.ToDate(), data.ProfileName());
                    $('#ChangeYearofAssessmentpop').modal('hide');
                    $('body').removeClass('modal-open');
                    $('.modal-backdrop').remove();
                }
                else {
                    CreateNewProfilefromsource(data.FromDate(), data.ToDate(), data.ProfileName(), data.SourceYear(), YrViewModel.JobType());
                    $('#ChangeYearofAssessmentpop').modal('hide');
                    $('body').removeClass('modal-open');
                    $('.modal-backdrop').remove();
                }
            }
            else {
                $('#valfactorerror').text("End date cannot be lesser than start date");
                $('#valfactorerror').show();
               
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: SaveYearChange() method in YearSetup.js';
            logger.logMessage(msg);
        }
    }
    //-----------------------------------------------------------------Function that is invoked on click of save for the create new assessment profile endss here--------------------------------


    function saveEditAssessmentProfilePopup(data, event) {
        try {
            var duplicate = 0;
            var ProfileId = data.ProfileId;
            var Profilename = data.Profilename;
            var Fromdate = data.Fromdate;
            var Todate = data.Todate;
            var HistProfileId = YrViewModel.SelectedHistProfile();
            if ((Date.parse(Todate) - Date.parse(Fromdate)) > 0) {
            for (i = 0; i < YrViewModel.ProfileofAssessmentList().length; i++) {
                if (YrViewModel.ProfileofAssessmentList()[i].Profilename() == Profilename && YrViewModel.ProfileofAssessmentList()[i].ProfileId() != ProfileId) {
                    duplicate++;
                    $('#valErrorYS').text("The '" + Profilename + "' named Assessment Period already exists.");
                    $('#valErrorYS').show();
                }
            }
                if (duplicate == 0) {
                    EditAssessmentProfile(ProfileId, Profilename, Fromdate, Todate, HistProfileId);
                    GetCurrentassessmentProfile();
                    $('#valErrorYS').hide();
                    //$('#editAssessmentPeriodDetails').modal('hide');
                    $('body').removeClass('modal-open');
                    $('.modal-backdrop').remove();
                }
            }
            else {
                $('#valErrorYS').text("End date cannot be lesser than start date");
                $('#valErrorYS').show();
            }


        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: saveEditAssessmentProfilePopup() method in YearSetup.js';
            logger.logMessage(msg);
        }
    }



    //----------------------------------------------------------------Function that is invoked on click of save of the change assesssmentprofile starts here----------------------------------- 
    function SaveChangeYearAssesment(data, event) {
        try {
            ChangeYear(YrViewModel.CurrentYearofAssessment(), YrViewModel.CurrentYear());
            $('#CommonChangeYearofAssessment').modal('hide');
            $('body').removeClass('modal-open');
            $('.modal-backdrop').remove();
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: SaveYearChange() method in YearSetup.js';
            logger.logMessage(msg);
        }
    }
    //---------------------------------------------------------------Function that is invoked on click od save of the change assessmentprofile ends here---------------------------------------


    //------------------------------------------------------------------Function that is used to save profile of assessmentr change starts here-------------------------
    function ChangeProfileofAssessment(data, event) {
        try {
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            return $.ajax({
                url: "/api/Calculation/ChangeProfileofAssessment",
                type: "POST",
                headers: headers,
                data: { SourceProfileId: YrViewModel.CurrentYear(), DestinationProfileId: data.SourceYear() }
            })
                .success(function (jsonResult, error) {
                    YrViewModel.UserMappingList([]);
                    var MappeduserProfileList = $.map(jsonResult, function (result) {
                        return new UserProfileMappingModel(result);
                    });
                    YrViewModel.UserMappingList(MappeduserProfileList);
                    YrViewModel.CurrentYear(data.SourceYear());
                    $("#CommonChangeYearofAssessment").modal('hide');

                    logger.logSuccess('Year of Assessment has been changed successfully.', 'Success', system.getModuleId(YrViewModel), true);
                    getAssessmentProfileDetails();

                })
                .fail(function (error, status) {
                    logger.logError('An error has occurred while changing the current year of assessment. Please contact your Administrator.', 'Error', system.getModuleId(YrViewModel), true);
                });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ChangeProfileofAssessment() method in YearSetup.js';
            logger.logMessage(msg);
        }
    }
    //------------------------------------------------------------------Function that is used to save profile of assessment change ends here------------------------------
    //-----------------------------------------------------------------Method that helps to show the date details on change of select starts here--------------------------------------
    function Profilechanged(data, event) {
        try {
            var id = parseInt(event.currentTarget.value);
            for (var i = 0; i < YrViewModel.ProfileofAssessmentList().length; i++) {
                if (id == parseInt(YrViewModel.ProfileofAssessmentList()[i].ProfileId())) {
                    $('#DisplayAssessmentDate').show()
                    document.getElementById('AssessmentDate').innerHTML = "From :" + YrViewModel.ProfileofAssessmentList()[i].Fromdate() + " To : " + YrViewModel.ProfileofAssessmentList()[i].Todate();

                }
            }

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: Profilechanged() method in CalculationStatus.js';
            logger.logMessage(msg);
        }
    }
    //-----------------------------------------------------------------Method that helps to show the date details on change of select ends here----------------------------------------


    function typedrpdownchange(data, event) {
        try {
            if (event.currentTarget.value == 1) {
                document.getElementById('Response1').checked = true;
                document.getElementById('Response2').checked = false;
                YrViewModel.Copyconfigurations(1);
                YrViewModel.Refreshconfigurations(1);
                $('#RefreshId').show();
            }
            if (event.currentTarget.value == 0) {
                document.getElementById('Response1').checked = false;
                document.getElementById('Response2').checked = true;
                YrViewModel.Copyconfigurations(0);
                YrViewModel.Refreshconfigurations(0);

                $('#RefreshId').hide();
            }
            return true;
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: typedrpdownchange() method in YearSetup.js';
            logger.logMessage(msg);
        }
    }

    function typedrpdownchangeRefresh(data, event) {
        try {
            if (event.currentTarget.value == 1) {
                document.getElementById('ResponseYes').checked = true;
                document.getElementById('ResponseNo').checked = false;
                YrViewModel.Refreshconfigurations(1);
            }
            if (event.currentTarget.value == 0) {
                document.getElementById('ResponseYes').checked = false;
                document.getElementById('ResponseNo').checked = true;
                YrViewModel.Refreshconfigurations(0);
            }
            return true;
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: typedrpdownchangeRefresh() method in YearSetup.js';
            logger.logMessage(msg);
        }
    }

    //----------------------------------------------------------------Functions for the freeze assessment profile functionality---------------------------------------------------------------------------------------
    function Freeze(data, event) {
        try {
            app.showMessage('Are you sure you want to freeze ' + data.YearofAssessment() + ' Year of Assessment', 'Freeze Year of Assessment?', ['Confirm', 'Cancel'], true, { buttonClass: "fa fa-check btn btn-primary", primaryButtonClass: "fa fa-check btn btn-success autofocus", popupIcon: 'title-icon col-md-1 fa fa-lock' })
                .then(function (option) {
                    if (option === 'Confirm') {
                        YrViewModel.FreezeYearOfAssessment(data.ProfileId());
                    }
                });

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: Freeze() method in YearSetup.js';
            logger.logMessage(msg);
        }
    }
    function FreezeYearOfAssessment(AssessmentProfileId) {
        try {
            try {
                $.ajax({
                    url: "/api/Calculation/FreezeAssesmentYear?AssessmentProfileId=" + AssesmentYear,
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders()
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source:ajax call from FreezeYearOfAssessment() method in YearSetup.js';
                logger.logMessage(msg);
            }
            function ajaxSuccess(jsonResult, status) {
                try {

                  if (jsonResult == '1') {
                        logger.logSuccess('Year of Assessment has been successfully frozen.', 'Success', system.getModuleId(YrViewModel), true);
                    }

                else
                      logger.logError(jsonResult + " - " + 'An error occurred while freezing year of assessment. Please contact your Administrator.', 'Error', system.getModuleId(YrViewModel), true);
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess from FreezeYearOfAssessment() method in YearSetup.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();

                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in FreezeYearOfAssessment() method in YearSetup.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail from FreezeYearOfAssessment() method in YearSetup.js';
                    logger.logMessage(msg);
                }
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajaxFail from FreezeYearOfAssessment() method in YearSetup.js';
            logger.logMessage(msg);
        }
    }
    //--------------------------------------------------------------Functions for the freeze assessment profile functionality-----------------------------------------------------------------------------------------


    //------------------------------Function that creates new profile of assessment without copying configurations starts here---------------
    function CreateNewProfilewithoutsource(FromDate, ToDate, ProfileName) {
        try {
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            $.ajax({
                url: "/api/Calculation/CreateNewProfilewithoutsource",
                headers: headers,
                type: "POST",
                data: { Profilename: ProfileName, Fromdate: FromDate, Todate: ToDate }
            })
                .success(ajaxSuccess)
                .fail(ajaxFail);
        } catch (e) {
            var msg = 'Exception: ' + e + ' | Source:ajax call from CreateNewProfilewithoutsource() method in YearSetup.js';
            logger.logMessage(msg);
        }
        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult == '1') {
                    logger.logSuccess('Assessment Period has been created successfully.', 'Success', system.getModuleId(YrViewModel), true);
                    getAssessmentProfileDetails();
                }
                else
                    logger.logError(jsonResult + " - " + 'An error occurred while creating new assessment period. Please contact your Administrator.', 'Error', system.getModuleId(YrViewModel), true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess from CreateNewProfilewithoutsource() method in YearSetup.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();

                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in CreateNewProfilewithoutsource() method in YearSetup.js';
                    logger.logMessage(msg);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail from CreateNewProfilewithoutsource() method in YearSetup.js';
                logger.logMessage(msg);
            }
        }
    }
    //------------------------------Function that creates new profile of assessment without copying configurations ends here-----------------



    function EditAssessmentProfile(ProfileId, ProfileName, FromDate, Todate, HistProfileId) {
        try {
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            $.ajax({
                url: "/api/Calculation/EditAssessmentProfile",
                type: "POST",
                headers: headers,
                data: { ProfileId: ProfileId, Profilename: ProfileName, Fromdate: FromDate, Todate: Todate, HistProfileId: HistProfileId }
            })
                .success(function (jsonResult, error) {
                    var code = jsonResult.slice(0, 2);
                    var msg = jsonResult.slice(3, 11);
                    if (code == '-3') {
                        logger.logError(msg + " - " + 'End date cannot be lesser than start date.', 'Error', system.getModuleId(YrViewModel), true);
                    }
                    else if (jsonResult == '1') {
                        $('#editAssessmentPeriodDetails').modal('hide');
                        logger.logSuccess('Assessment Period has been edited successfully.', 'Success', system.getModuleId(YrViewModel), true);
                        getAssessmentProfileDetails();
                    }
                    else
                        logger.logError(jsonResult + " - " +'An error occurred while editing new assessment period. Please contact your Administrator.', 'Error', system.getModuleId(YrViewModel), true);

                })
                .fail(function (error, status) {
                    logger.logError('An error has occurred while editing the Assessment Period. Please contact the Application Administrator.', 'Error', system.getModuleId(YrViewModel), true);
                });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in EditAssessmentProfile() method in YearSetup.js';
            logger.logMessage(msg);
        }
    }



    //-----------------------------Function that creates new profile of assessment by copyinf configurations from source year starts here------------------
    function CreateNewProfilefromsource(FromDate, Todate, ProfileName, SourceProfileId, JobType) {
        try {
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            $.ajax({
                url: "/api/Calculation/CreateNewProfilefromsource",
                type: "POST",
                headers: headers,
                data: { ProfileId: SourceProfileId, Profilename: ProfileName, Fromdate: FromDate, Todate: Todate, RefreshFlag: YrViewModel.Refreshconfigurations(), JobType: JobType }
            })
                .success(function (jsonResult, error) {
                    if (jsonResult == '1') {
                        $('#ChangeYearofAssessmentpop').modal('hide');
                        $('body').removeClass('modal-open');
                        $('.modal-backdrop').remove();
                        logger.logSuccess('Assessment Period Creation has been initiated.', 'Success', system.getModuleId(YrViewModel), true);

                        getAssessmentProfileDetails();
                    }
                    else
                        logger.logError(jsonResult + " - " + 'An error occurred while creating new assessment period. Please contact your Administrator.', 'Error', system.getModuleId(YrViewModel), true);

                })
                .fail(function (error, status) {
                    logger.logError('An error has occurred while creating the Assessment Period. Please contact the Application Administrator.', 'Error', system.getModuleId(YrViewModel), true);
                });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in CreateNewProfilefromsource() method in UserRole.js';
            logger.logMessage(msg);
        }
    }
    //---------------------------Function that creates new profile of assessment by copying configurations from source year neds here----------------------

    function RefreshScheduledJob() {
        try {
            getAssessmentProfileDetails();
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RefreshScheduledJob() method in CalculationStatus.js';
            logger.logMessage(msg);
        }
    }

    //------------------------------Function that gets the current assessment profile starts here----------------------------------------------------------------------------------------

    function GetCurrentassessmentProfile() {
        try {
            var headers = appsecurity.getSecurityHeaders();
            return $.ajax({
                url: "/api/Calculation/GetCurrentassessmentProfile",
                type: "GET",
                headers: headers
            })
                .success(function (jsonResult, error) {
                    if (jsonResult.length > 0 && jsonResult[0].Incident_Description != null) {
                        logger.logError(jsonResult[0].Incident_Description + " - " + 'An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(YrViewModel), true);
                    }
                    YrViewModel.CurrentYear(jsonResult[0].ProfileId);
                    YrViewModel.CurrentAssesmentProfile(jsonResult[0].Profilename)
                    YrViewModel.appsecurity.GetCurrentProfileOfAssessment();
                })
                .fail(function (error, status) {
                    logger.logError('An error has occurred while creating the Assessment Period. Please contact the Application Administrator.', 'Error', system.getModuleId(YrViewModel), true);
                });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in GetCurrentassessmentProfile() method in UserRole.js';
            logger.logMessage(msg);
        }
    }
    //------------------------------Function that gets the current assessment profile ends here------------------------------------------------------------------------------------------


    //-----------------------------------------------------------------------Function that gets call on change of the Destinationdropdown in the change profile popup starts here---------------------------
    function ProfilechangedChangeYearPopup(data, event) {
        try {
            var id = parseInt($('#ProfileDrpdwn').val());
            $('#DisplayAssessmentDateChangeyearPopup').show();
            for (var i = 0; i < YrViewModel.ProfileofAssessmentList().length; i++) {
                if (id == parseInt(YrViewModel.ProfileofAssessmentList()[i].ProfileId())) {
                    $('#DisplayAssessmentDate').show()
                    document.getElementById('AssessmentDateChangeyearPopup').innerHTML = "From :" + YrViewModel.ProfileofAssessmentList()[i].Fromdate() + " To : " + YrViewModel.ProfileofAssessmentList()[i].Todate();

                }
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in ProfilechangedChangeYearPopup() method in UserRole.js';
            logger.logMessage(msg);
        }
    }
    //------------------------------Function that gets called on change of the Destinationdropdown in the change profile popup ends here-----------------------------

    //------------------------------Function that gets the userdetails starts here--------------------------------------------------------------------------------
    function GetUserProfileMappings() {
        try {
            return $.ajax({
                url: "/api/Calculation/GetAllUserMappings",
                type: "GET",
                headers: appsecurity.getSecurityHeaders(),
                data: { ProfileId: parseInt(YrViewModel.PopUpOpenProfileId()) }
            })
                .success(function (jsonResult, error) {
                    if (jsonResult.length > 0 && jsonResult[0].Incident_Description != null) {
                        logger.logError(jsonResult[0].Incident_Description + " - " + 'An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(YrViewModel), true);
                    }
                    YrViewModel.UserMappingList([]);
                    tableObj = $('#UserProfileMappingTable').DataTable();

                    tableObj.destroy();
                    $('#UserProfileMappingTable tbody tr').remove();

                    var MappeduserProfileList = $.map(jsonResult, function (result) {
                        return new UserProfileMappingModel(result);
                    });
                    YrViewModel.UserMappingList(MappeduserProfileList);
                    $('#UserProfileMappingTable').dataTable();
                })
                .fail(function (error, status) {
                    logger.logError('An error has occurred while fetching the User Details.', 'Error', system.getModuleId(YrViewModel), true);
                });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in GetUserProfileMappings() method in UserRole.js';
            logger.logMessage(msg);
        }
    }
    //------------------------------Function that gets UserDetails ends here--------------------------------------------------------------------------------------
    //------------------------------Function That gets called on click of the manageuseractions action button starts here-------------------------------------------------------------------
    function OpenUserDetailsPopup(data, event) {
        try {

            YrViewModel.PopUpOpenProfileId(parseInt(data.ProfileId()));

            GetUserProfileMappings().then(function () {
                YrViewModel.popUpTitle("Mapped Users");
                YrViewModel.addPopUpCss(true);
                $('#UserProfileMapping').modal('show');
                $("#selectall").prop("checked", false);
            })


        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in OpenUserDetailsPopup() method in UserRole.js';
            logger.logMessage(msg);
        }
    }
    //------------------------------Function that gets called on click of the manageuseractions action button ends here---------------------------------------------------------------------

    //------------------------------Logic to Fetch User Details and List of All Roles Starts Here----------------------------------------------

    //------------------------------Function to save the user profile mapping starts here----------------------
    function SaveUserProfileMapping(data, event) {
        try {

            var userList = JSON.stringify($.map(data.UserMappingList(), function (result) {
                if (result.IsMapped() == true) {
                    return { UserId: result.UserId(), ProfileId: YrViewModel.PopUpOpenProfileId() };
                }
            }));
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            return $.ajax({
                url: "/api/Calculation/SaveUserProfileMappings",
                type: "POST",
                headers: headers,
                contentType: 'application/json',
                dataType: 'json',
                data: userList
            })
                .success(function (jsonResult, error) {
                    YrViewModel.UserMappingList([]);
                    var MappeduserProfileList = $.map(jsonResult, function (result) {
                        return new UserProfileMappingModel(result);
                    });
                    YrViewModel.UserMappingList(MappeduserProfileList);
                    $('#UserProfileMapping').modal('hide');
                    logger.logSuccess('Users has been assigned successfully to Profile.', 'Success', system.getModuleId(YrViewModel), true);

                })
                .fail(function (error, status) {
                    logger.logError('An error has occurred while saving the User Details.', 'Error', system.getModuleId(YrViewModel), true);
                });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in SaveUserProfileMapping() method in UserRole.js';
            logger.logMessage(msg);
        }
    }
    //-----------------------------------------------------------------------Function to save the user profile mapping ends here-------------------------


    //-----------------------------------------------------------------------Function Thats gets called on hit of SelectAllUsers checkbox starts here-------------------------
    function SelectAllUsers(data, event) {
        try {
            if (event.currentTarget.checked) {
                for (var i = 0; i < YrViewModel.UserMappingList().length; i++) {
                    YrViewModel.UserMappingList()[i].isChecked(event.currentTarget.checked);
                }
            }
            else {
                for (var i = 0; i < YrViewModel.UserMappingList().length; i++) {
                    YrViewModel.UserMappingList()[i].isChecked(event.currentTarget.checked);
                }
            }
            var rows = $("#UserProfileMappingTable").dataTable().fnGetNodes();
            var cells = [];
            for (var i = 0; i < rows.length; i++) {
                if (event.currentTarget.checked == true)
                    $(rows[i]).find("td:eq(0)").find('input').prop("checked", true);
                else
                    $(rows[i]).find("td:eq(0)").find('input').prop("checked", false);
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in SelectAllUsers() method in UserRole.js';
            logger.logMessage(msg);
        }
    }
    //-----------------------------------------------------------------------Functions that gets called on click of SelectAllUsers checkbox ends here-------------------------
    function YearofAssessmentModel(item) {
        try {

            var self = this;
            self.ConfigurationFreezeFlag = ko.observable($('<div/>').html(item.ConfigurationFreezeFlag).text());
            self.YearofAssessment = ko.observable($('<div/>').html(item.YearofAssessment).text());
            self.ConfigStatus = ko.observable($('<div/>').html(item.ConfigStatus).text());
            self.CalculationStatus = ko.observable($('<div/>').html(item.CalculationStatus).text());
            self.FreezeStatus = ko.observable($('<div/>').html(item.FreezeStatus).text());

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: YearofAssessmentModel() method in CalculationStatus.js';
            logger.logMessage(msg);
        }
    }


    function EditAssessmentProfileModel(item) {
        try {
            var self = this;
            self.Fromdate = item.Fromdate;
            self.Todate = item.Todate;
            self.ProfileId = item.ProfileId;
            self.Profilename = item.Profilename;
            self.HistProfileId = item.HistProfileId;
            self.HistProfileName = item.HistProfileName;
            self.RefreshProfileId = item.RefreshProfileId;
            self.RefreshProfileName = item.RefreshProfileName;
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: EditAssessmentProfileModel() method in CalculationStatus.js';
            logger.logMessage(msg);
        }
    }


    //Model to Store the Profileofassessmentdetails
    function ProfileofAssessmentModel(item) {
        try {
            var self = this;
            //self.ConfigurationFreezeFlag = ko.observable('true');
            self.ConfigurationFreezeFlag = ko.observable($('<div/>').html(item.ConfigurationFreezeFlag).text());
            self.Fromdate = ko.observable($('<div/>').html(item.Fromdate).text());
            self.Todate = ko.observable($('<div/>').html(item.Todate).text());
            self.ProfileId = ko.observable($('<div/>').html(item.ProfileId).text());
            self.Profilename = ko.observable($('<div/>').html(item.Profilename).text());
            self.HistProfileId = ko.observable($('<div/>').html(item.HistProfileId).text());
            self.HistProfileName = ko.observable($('<div/>').html(item.HistProfileName).text());
            self.RefreshProfileId = ko.observable($('<div/>').html(item.RefreshProfileId).text());
            self.RefreshProfileName = ko.observable($('<div/>').html(item.RefreshProfileName).text());
            if (item.JobStatus == "") {
                self.JobStatus = ko.observable("NA");
            }
            else {
                self.JobStatus = ko.observable($('<div/>').html(item.JobStatus).text());
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ProfileofAssessmentModel() method in CalculationStatus.js';
            logger.logMessage(msg);
        }
    }

    //Model to store the mapping between user and profile 
    function UserProfileMappingModel(item) {
        try {
            var self = this;
            self.UserId = ko.observable(item.UserId);
            self.UserName = ko.observable($('<div/>').html(item.UserName).text());
            self.PrimaryRoleName = ko.observable($('<div/>').html(item.PrimaryRoleName).text());
            self.IsMapped = ko.observable(item.IsActive);
            self.isChecked = ko.observable(false);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: UserProfileMappingModel() method in CalculationStatus.js';
            logger.logMessage(msg);
        }
    }

    //------------------------------------------------------------------------Model Definition Ends Here-----------------------------------------------------------------------------

});
